import CrudPage from "./CrudPage";

const fields = [
  { name: "title", label: "Event Title", required: true },
  { name: "date", label: "Date", type: "date", required: true },
  { name: "location", label: "Location", placeholder: "e.g. Lincoln High School" },
  { name: "description", label: "Description", type: "textarea", span: "full" },
  { name: "is_past", label: "Past Event", type: "checkbox", checkboxLabel: "This event has already happened" },
];

const columns = [
  { key: "title", label: "Title" },
  { key: "date", label: "Date" },
  { key: "location", label: "Location" },
  { key: "is_past", label: "Past", render: (r) => (r.is_past ? "✓" : "—") },
];

export default function AdminOutreach() {
  return (
    <CrudPage
      title="Outreach Events"
      endpoint="/outreach"
      fields={fields}
      columns={columns}
      testidPrefix="outreach"
      emptyDefaults={{ title: "", date: new Date().toISOString().slice(0, 10), location: "", description: "", is_past: false }}
    />
  );
}
